import { Component, OnInit, ViewEncapsulation, ViewChild, Input, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { MatTable, MatDialog, MatDatepickerInputEvent } from '@angular/material';
import { ScheduleDate, LoanScheduleDate, CompanyRef, Wage, LoanParameters, Parameter } from '@akiba/models_bimbo';
import { Subscription } from 'rxjs';
import { SelectionModel } from '@angular/cdk/collections';
import { Installment } from '@akiba/models_bimbo';
import { AppState } from 'projects/bimbo/src/app/models/appState';
import { LogicService } from 'projects/bimbo/src/app/services/logic.service';
import { InfoDialogComponent } from 'projects/bimbo/src/app/dialogs/info-dialog/info-dialog.component';
import * as moment from 'moment';

@Component({
  selector: 'app-rl-parameters',
  templateUrl: './rl-parameters.component.html',
  styleUrls: ['./rl-parameters.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class RlParametersComponent implements OnInit, OnDestroy, OnChanges {

  displayedInstallmentsColumns: string[] = ['weeks', 'biWeeks', 'months', 'select'];
  days = [{ dateDay: 1, dateString: 'Lunes' }, { dateDay: 2, dateString: 'Martes' }, { dateDay: 3, dateString: 'Miércoles' }, { dateDay: 4, dateString: 'Jueves' }, { dateDay: 5, dateString: 'Viernes' }, { dateDay: 6, dateString: 'Sábado' }, { dateDay: 7, dateString: 'Domingo' }];
  @ViewChild('loanDatesTable', { static: false }) loanDatesTable: MatTable<ScheduleDate>;
  @ViewChild('wageTable', { static: false }) wageTable: MatTable<Wage>;
  displayedLoanDatesColumns: string[] = ['InicioPrestamo', 'FinPrestamo', 'day', 'active', 'delete'];
  displayedWageColumns: string[] = ['wageID', 'wageName', 'active'];

  selectionWagesSubscription: Subscription = null;
  appLogicChangesSubscription: Subscription = null;
  generalDataSubscription: Subscription = null;

  selectionWages: SelectionModel<Wage>;
  selectionInstallments: SelectionModel<Installment>;

  newRLoanDate = new LoanScheduleDate();
  contentLocation: AppState = new AppState();

  //fecha fin
  isEndDate = false;
  dateMaxPayments: any;
  existDate = false;

  selectionInstallmentsSubscription: Subscription = null;

  @ViewChild('installmentsTable', { static: false }) installmentsTable: MatTable<Installment>;
  @Input() disabled: boolean;
  @Input() modParameter: LoanParameters;
  constructor(public logicService: LogicService, public dialog: MatDialog) {
    this.selectionWages = new SelectionModel<Wage>(true, []);
    this.selectionInstallments = new SelectionModel<Installment>(false, []);

    this.generalDataSubscription = this.logicService.dataManager.generalDataLoader.changes.subscribe(r => {
      if (r && r.response) {
        this.doSubscriptions();
      }
    });

    this.logicService.dataManager.generalDataLoader.load();

  }

  ngOnChanges(changes: SimpleChanges): void {
    this.doSubscriptions();
  }

  ngOnInit() {
  }

  switchTo(anIndex: number) {
    this.contentLocation.savingParametersIndex = anIndex;
  }

  doSubscriptions() {

    if (this.modParameter && this.logicService.dataManager.parameterDataLoader.installments && this.logicService.dataManager.parameterDataLoader.installments.length) {

      // this.installments = this.logicService.dataManager.parameterDataLoader.installments.filter(element => element !== null);

      this.selectionWages = new SelectionModel<Wage>(true, [], true);

      if (this.selectionInstallmentsSubscription && !this.selectionInstallmentsSubscription.closed) {
        this.selectionInstallmentsSubscription.unsubscribe();
        this.selectionInstallmentsSubscription = null;
      }

      this.selectionInstallments = new SelectionModel<Installment>(false, []);

      this.logicService.dataManager.parameterDataLoader.installments.forEach(element => {
        if (this.modParameter && this.modParameter.maxPayments && this.modParameter.maxPayments.installmentID === element.installmentID) {
          this.selectionInstallments.select(element);
        }
      });

      this.selectionInstallmentsSubscription = this.selectionInstallments.changed.subscribe(x => {
        if (x.added.length) {
          this.modParameter.maxPayments = x.added[0];
        } else if (x.removed.length) {
          this.modParameter.maxPayments = null;
        }
      });

      if (this.installmentsTable) {
        this.installmentsTable.renderRows();
      }

      if (this.selectionWagesSubscription && !this.selectionWagesSubscription.closed) {
        this.selectionWagesSubscription.unsubscribe();
        this.selectionWagesSubscription = null;
      }

      this.selectionWagesSubscription = this.selectionWages.changed.subscribe(x => {

        if (x.added.length) {

          x.added.forEach(element => {
            const index = this.modParameter.wageTypes.findIndex(ic => ic === element.wageID);
            if (index < 0) {
              this.modParameter.wageTypes.push(element.wageID);
            }
          });

        } else if (x.removed.length) {

          x.removed.forEach(element => {
            const index = this.modParameter.wageTypes.findIndex(ic => ic === element.wageID);
            this.modParameter.wageTypes.splice(index, 1);
          });

        }

      });

      if (this.logicService.dataManager.generalDataLoader.wages && this.modParameter) {

        this.logicService.dataManager.generalDataLoader.wages.forEach(cr => {
          const index = this.modParameter.wageTypes.indexOf(cr.wageID);
          if (index >= 0) {
            this.selectionWages.select(cr);
          }
        });

      }



      if (this.wageTable) {
        this.wageTable.renderRows();
      }

      if (this.loanDatesTable) {
        this.loanDatesTable.renderRows();
      }
      this.dateMaxPayments = this.modParameter.dateMaxPayments;
      this.existDate = this.dateMaxPayments != null ? true : false;
      this.isEndDate = false;
    }


  }

  reset() {
    this.isEndDate = false;
    this.dateMaxPayments = undefined;
    this.newRLoanDate = new LoanScheduleDate();
    this.newRLoanDate.startDate = null;
    this.newRLoanDate.endDate = null;
    this.newRLoanDate.scheduleDay = null;
    this.selectionInstallments.clear();

  }

  scheduleDay(day: number): string {
    const d = this.days.find(element => element.dateDay === day);
    if (d !== undefined) {
      return d.dateString;
    }
    return '';
  }

  setRegistrationDate(type: string, event: MatDatepickerInputEvent<moment.Moment>) {

    if (type === 'starts') {

      this.newRLoanDate.startDate = event.value.toDate();
      const nextDay = moment(event.value);

      if (!this.newRLoanDate.endDate) {
        this.newRLoanDate.endDate = nextDay.toDate();
      }

      this.newRLoanDate.weekNumber = event.value.isoWeek();
      const isoWeek = event.value.isoWeek() / 2;
      this.newRLoanDate.biWeekNumber = Math.ceil(isoWeek);

    } else if (type === 'ends') {

      if (!this.newRLoanDate.startDate) {

        this.dialog.open(InfoDialogComponent, {
          data: {
            message: 'La necesario especificar la fecha de fin de ciclo.',
            close: 'Aceptar'
          }
        });

        this.newRLoanDate.endDate = null;

        return false;

      }

      const sM = moment(this.newRLoanDate.startDate);
      const eM = event.value;

      if (eM.isSameOrBefore(sM, 'day')) {

        this.dialog.open(InfoDialogComponent, {
          data: {
            message: 'La fecha de fin de ciclo no puede ser el mismo dia que la fecha de inicio.',
            close: 'Aceptar'
          }
        });

        this.newRLoanDate.endDate = null;
        return false;

      }

      this.newRLoanDate.endDate = eM.toDate();

    }

  }

  deleteInstallments(index: number) {
    const temp = this.logicService.dataManager.parameterDataLoader.installments;
    temp.splice(index, 1);
    this.logicService.dataManager.parameterDataLoader.installments = temp;
  }

  addDate() {

    if (!this.newRLoanDate.startDate || !this.newRLoanDate.endDate || !this.newRLoanDate.scheduleDay) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'La información de fecha de ciclo esta incompleta.',
          close: 'Aceptar'
        }
      });
      return;

    }

    this.newRLoanDate.active = true;
    this.modParameter.loanDates.push(this.newRLoanDate);
    this.newRLoanDate = new LoanScheduleDate();
    this.newRLoanDate.startDate = null;
    this.newRLoanDate.endDate = null;

    if (this.loanDatesTable) {
      this.loanDatesTable.renderRows();
    }

  }

  deleteLoanDate(index: number) {
    this.modParameter.loanDates.splice(index, 1);
    this.loanDatesTable.renderRows();
  }

    /////////////fecha fin alterna (dateChange)="setRegistrationDate('starts', $event)"

    activateEndDate(event) {
      this.isEndDate = event;
      if (this.dateMaxPayments) {
        this.dateMaxPayments = undefined;
      }
  
      if (event == false) {
        this.dateMaxPayments = undefined;
      }
    }

    setDateMaxPayments(event: MatDatepickerInputEvent<moment.Moment>){

      if(event.value){
        this.modParameter.dateMaxPayments = this.dateMaxPayments.toDate();
      }

    }
  
    deleteDateLoan(event) {
  
      if (event == this.dateMaxPayments) {
        this.dateMaxPayments = undefined;
        this.existDate = false;
      }
  
    }
  

  ngOnDestroy(): void {
    if (this.selectionWagesSubscription && !this.selectionWagesSubscription.closed) {
      this.selectionWagesSubscription.unsubscribe();
      this.selectionWagesSubscription = null;
    }

    if (this.appLogicChangesSubscription && !this.appLogicChangesSubscription.closed) {
      this.appLogicChangesSubscription.unsubscribe();
      this.appLogicChangesSubscription = null;
    }

  }

}
